import React from 'react';

import { Field } from 'redux-form';

import * as Dropdown from 'components/Dropdown';

const ParameterLevelDropdownComponent = props =>
  <div className="main-dropdown mb-20">
    <p className="main-dropdown__label">
      Level of Variable 1
    </p>

    <Field
      {...props}
      placeholder="Select a Level of Variable 1"
      component={Dropdown.ReduxFormWrapper}
    />
  </div>;

export default ParameterLevelDropdownComponent;
